module.exports = __webpack_public_path__ + "img/ski_cos0.a8a98705.png";